import { useContext, useEffect, useState, useMemo } from "react"
import { Routes, Route, Link } from 'react-router-dom'
import { fetchData } from "../../../utils/fetch";
import { LanguageContext } from "../../../utils/lang_provider";
import Pagination from "../../../templates/pagination"
import UserEdit from "./user_edit";
import { Button, Flex, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'

export default function Users() {
  const [users, setUsers] = useState([]);
  const { language } = useContext(LanguageContext)
  const [currentPage, setCurrentPage] = useState(0);
  const maxUsersOnPage = 10;
  const [totalPages, setTotalPages] = useState(0);
  
  const options = useMemo(() => ({
    offset: currentPage * maxUsersOnPage,
    limit: maxUsersOnPage,
    type: "BACK"
  }), [currentPage, maxUsersOnPage]);
  useEffect(() => {
    async function loadUsers() {
        try {
            const data = await fetchData(`admin/users`, language, options);
            setUsers(data.users);
            setTotalPages(Math.ceil(data.total_count / maxUsersOnPage));
        } catch (error) {
            console.error('Error loading users:', error);
        }
    }
    loadUsers();
  }, [language, setUsers, options]);

  const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
      window.scrollTo(0, 0);
  };

  return (
    <div className="">
      <Routes>
        <Route path="/list" element={<UsersList users={users} />}></Route>
        <Route path="/edit/:id" element={<UserEdit />}></Route>
      </Routes>
      <Pagination totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange}/>
    </div>
  )
}

function UsersList({ users }) {
  const deleteUser = () => { return; };

  return (
    <Flex vertical style={{margin: "0 5% 0 5%"}}>

    <table className="table">
      <thead>
        <tr>
          <th>Meno</th>
          <th>Priezvisko</th>
          <th>Email</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {users.map(user => (
          <tr>
            <td>{user.firstname}</td>
            <td>{user.lastname}</td>
            <td>{user.username}</td>
            <td>{user.status}</td>
            <td>
                <Flex justify="space-evenly">
                  <Link to={`/admin/user/edit/${user.id}`}>
                    <Button filled>
                        <EditOutlined></EditOutlined>
                    </Button>
                  </Link>
                  <Popconfirm
                    title="Delete user"
                    description="Delete the user?"
                    onConfirm={() => {deleteUser()}}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button danger><DeleteOutlined></DeleteOutlined></Button>
                  </Popconfirm>
                </Flex>
              </td>
          </tr>
        ))}
      </tbody>
    </table>
        </Flex>
  )
}